export default __webpack_public_path__ + "static/media/ketchup.e74a5536.png";